export default function Card(theme) {
  return {
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          boxShadow: 'none',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease',
          // Nested cards inside CardContent should have transparent background with solid border
          '& .MuiCardContent-root .MuiCard-root': {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            backdropFilter: 'none',
            border: '1px solid rgba(0, 0, 0, 1)',
          },
          // Nested cards inside CardContent with Container in between
          '& .MuiCardContent-root .MuiContainer-root .MuiCard-root': {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            backdropFilter: 'none',
            border: '1px solid rgba(0, 0, 0, 1)',
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '&:last-child': {
            paddingBottom: theme.spacing(3),
          },
          // Cards nested inside CardContent should have transparent background with solid border
          '& .MuiCard-root': {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            backdropFilter: 'none',
            border: '1px solid rgba(0, 0, 0, 1)',
            // Box components inside nested cards should have visible borderBottomColor when borderBottom is set
            '& .MuiBox-root': {
              borderBottomColor: 'rgba(0, 0, 0, 0.1) !important',
            },
          },
          // Cards nested inside CardContent with Container in between
          '& .MuiContainer-root .MuiCard-root': {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            backdropFilter: 'none',
            border: '1px solid rgba(0, 0, 0, 1)',
            // Box components inside nested cards should have visible borderBottomColor when borderBottom is set
            '& .MuiBox-root': {
              borderBottomColor: 'rgba(0, 0, 0, 0.1) !important',
            },
          },
        },
      },
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1.5, 3),
          gap: theme.spacing(1),
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 2),
        },
        title: {
          fontWeight: 400,
          fontSize: '0.9375rem', // 15px - slightly reduced to match card titles
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        },
        subheader: {
          color: theme.palette.text.secondary,
        },
      },
    },
  };
}

